import {HttpHeaders} from "@angular/common/http";

const credentials = btoa('dynamic-leads:wqbn1KG7iZL9BT1bIyFOrUfeVX')

export const environment = {
  production: false,
  apiUrl: '/gateway/api/soelead/dynamic',
  authToken: 'Basic ' + credentials,
  plainHeaders: new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8'),
};
